/***
 * Created on 2023/10/25
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import sharedI18n from "common/SharedI18n";
import {I18nextProvider} from "react-i18next";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import ForgetPasswordIndex from "./forget_password_index";
import EmailSentComponent from "./email_sent_component";
import ForgetPasswordPhone from "./forget_password_phone";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

function ForgetPassword({}) {
    const [qid, setQid] = useState();

    const MiniRouter = () => {
        return (
            <BrowserRouter future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }}>
                <Routes>
                    <Route path="/forget_password" element={<ForgetPasswordIndex qid={qid} setQid={setQid}/>}></Route>
                    <Route path="/forget_password/phone_verify" element={<ForgetPasswordPhone qid={qid}/>} />
                    <Route path="/forget_password/success" element={<EmailSentComponent qid={qid}/>} />
                </Routes>
            </BrowserRouter>
        );
    }


    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <MiniRouter />
            </QueryClientProvider>
        </I18nextProvider>
    );
}


export default ForgetPassword;